export type WhatsappOverviewMessages = {
  whatsappOverviewText1: string;
  whatsappOverviewText2: string;
  whatsappOverviewText3: string;
  whatsappOverviewArticleLinkText: string;
  whatsappOverviewArticleLinkSource: string;
};

export const whatsappOverviewMessages: WhatsappOverviewMessages = {
  whatsappOverviewText1:
    "Conecte sua conta agora mesmo e transforme o WhatsApp numa verdadeira plataforma de vendas on-line.",
  whatsappOverviewText2: "Deseja saber mais sobre o processo de conexão de sua conta?",
  whatsappOverviewText3: "Acesse a documentação: ",
  whatsappOverviewArticleLinkText: "Conexão com o WhatsApp",
  whatsappOverviewArticleLinkSource:
    "https://talk2buy.tomticket.com/kb/plataforma/t2b-pop-configuracao-plataformas-whatsapp",
};
